if (!customElements.get('vb-pdp-video')) {
  customElements.define('vb-pdp-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const button = this.querySelector('button');
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.player) return;
        window.pauseAllMedia?.();
        const video = this.querySelector('template').content.querySelector('video').cloneNode(true);
        // The source exists only in an inert template until a user activates it.
        this.player = video;
        this.appendChild(video);
        button.hidden = true;
        video.focus({ preventScroll: true });
        // Keep native controls available when a browser declines playback.
        video.play().catch(() => {});
      });
    }
    disconnectedCallback() {
      this.player?.pause();
    }
  });
}
